import { useEffect, useState } from "react";
import PortalFooter from "../Reactportal/PortalFooter";
import Reactportal from "../Reactportal/Reactportal";
import "./CommonMultiSelectComponent.scss";
import CompanyList from "./CompanyList";
import { useModalContext } from "../Reactportal/ModalContext";


const FirstSectionModal = ({
  show,
  data,
  selectedBranches,
  getSelectedBranches,
  fielddata,
  query,
  TypeOfPortal,
  setModal,
}) => {

  const Key="Vehicle_Select";
  const { pushModal, popModal } = useModalContext();
  const [selectedCompanyId, setSelectedCompanyId] = useState(null);
  const [showBranchSection, setShowBranchSection] = useState(false);
  const [openModal, setOpenModal] = useState(show);

 
  useEffect(() => {
    pushModal(Key);
    return () => {
      popModal(Key)
    }
  }, []);


  const Closeformfunction1 = () => {
    setModal();
    setOpenModal(false);
  };
  const submit = async () => {};



  const handleSelectCompany = (companyId) => {
    setSelectedCompanyId(companyId);
    setShowBranchSection(true);
  };
  return (
    <>
      {openModal ? (
        <Reactportal
          open={openModal}
          onClose={Closeformfunction1}
          TypeOfPortal={TypeOfPortal}
        >
          <div className="CompanyBranchTables">
            <CompanyList
              data={data}
              query={query}
              TypeOfPortal={TypeOfPortal}
              selectedBranches={selectedBranches}
              getSelectedBranches={(data) => getSelectedBranches(data)}
              fielddata={fielddata}
              handleSelectCompany={handleSelectCompany}
            />
          </div>
          <div>
            <PortalFooter
              renderContent={() => (<></>)}
              submitform={submit}
              submitType={""}
              Form_key={Key}
              handleformclose={() => {
                Closeformfunction1();
                setOpenModal(!openModal);
              }}
              Cancletype={"Close"}
            />
          </div>
        </Reactportal>
      ) : (
        <div></div>
      )}
    </>
  );
};

export default FirstSectionModal;
